export default "__VITE_ASSET__DuoI2Et7__"